import makeService from './api';

export default makeService('bug_types');
